import React, {useEffect, useRef, useState} from 'react';
import styles from './Hospitality.module.css';
import h11 from 'assets/lp/h11.png';
import h22 from 'assets/lp/h22.png';
import h33 from 'assets/lp/h33.png';
import h44 from 'assets/lp/h44.png';
import h55 from 'assets/lp/h55.png';
import h66 from 'assets/lp/h66.png';
import arrow1 from 'assets/lp/arrow1.png';
import arrow2 from 'assets/lp/arrow2.png';

const hospitalitylp: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [hospitalityWidth, sethospitalityWidth] = useState(500);
  const [totalhospitality, setTotalhospitality] = useState(3); // Variabilă de stare pentru totalhospitality
  const carouselRef = useRef<HTMLDivElement | null>(null);

  // Hook pentru a actualiza lățimea recenziei pe baza dimensiunii ferestrei
  useEffect(() => {
    const handleResize = () => {
      if (typeof window !== 'undefined') {
        // Verificăm dimensiunea ferestrei pentru a ajusta lățimea fiecărui slide și totalul slide-urilor
        const newWidth = window.innerWidth <= 992 ? 360 : 511;
        sethospitalityWidth(newWidth);
        setTotalhospitality(window.innerWidth <= 768 ? 6 : 4); // 6 pe mobil, 4 pe desktop
      }
    };

    // Setează lățimea inițială și totalhospitality la montarea componentului
    handleResize();

    // Adaugă un event listener pentru redimensionarea ferestrei
    window.addEventListener('resize', handleResize);

    // Curăță event listener-ul la demontarea componentului
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const setPositionByIndex = () => {
      if (carouselRef.current) {
        // Calculăm distanța de translatare exactă pe baza indexului curent și lățimii fiecărui slide
        const currentTranslate = currentIndex * -hospitalityWidth;
        carouselRef.current.style.transform = `translateX(${currentTranslate}px)`;
      }
    };

    setPositionByIndex();
  }, [currentIndex, hospitalityWidth]);

  const handleNext = () => {
    if (currentIndex < totalhospitality - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      setCurrentIndex(0); // Revine la primul slide
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    } else {
      setCurrentIndex(totalhospitality - 1); // Se duce la ultimul slide
    }
  };

  return (
    <section className={styles.hospitalitya}>
      <div className={styles.sectiontitlehospitality}>Enhance Your Hospitality Business <br/>with EV Charging Solutions
      </div>
      <div className={styles.sectionsubtitlehospitality}>Attract eco-conscious, high-income travelers, boost guest
        satisfaction, and generate new revenue <br/>streams with Energy5's turnkey EV charging stations tailored for the
        hospitality industry.
      </div>
      <div className={styles.elementwrapper}>
        <div className={styles.carouselwrapper}>
          <div className={styles.carousel} ref={carouselRef}>
            <div className={styles.hospitalityb}>
              <img className={styles.hospitalityimage} src={h11} alt="hospitality 1"/>
              <p className={styles.hospitalityname}>Boost Guest <br/>Loyalty</p>
              <p className={styles.hospitalitycontent}>Eco-conscious travelers prefer hotels with reliable EV charging.
                Installing Energy5's EV chargers increases guest satisfaction and loyalty, encouraging return visits.
                Guests will feel secure knowing their vehicles are charged and ready to go, making them more likely to
                extend their stay.</p>
            </div>

            <div className={styles.hospitalityb}>
              <img className={styles.hospitalityimage} src={h22} alt="hospitality 1"/>
              <p className={styles.hospitalityname}>Unlock New <br/> Revenue Opps</p>
              <p className={styles.hospitalitycontent}>EV chargers offer a new revenue source through charging fees
                while enhancing hotel visibility on travel platforms. Energy5's solutions help your hotel generate
                passive income, attracting more guests and boosting occupancy rates.</p>
            </div>

            <div className={styles.hospitalityb}>
              <img className={styles.hospitalityimage} src={h33} alt="hospitality 1"/>
              <p className={styles.hospitalityname}>Appeal to High-<br/>Income Guests</p>
              <p className={styles.hospitalitycontent}>EV charging attracts affluent, eco-conscious travelers who seek
                sustainable accommodations. Position your hotel or restaurant as a green leader, boosting your
                reputation and appealing to high-income guests with this future-focused amenity.</p>
            </div>

            <div className={styles.hospitalityb}>
              <img className={styles.hospitalityimage} src={h44} alt="hospitality 1"/>
              <p className={styles.hospitalityname}>Gain a Competitive <br/>Advantage</p>
              <p className={styles.hospitalitycontent}>Stay ahead of hospitality trends by offering EV charging. With
                26% of U.S. hotels and restaurants already equipped, investing now keeps your business relevant and
                showcases your commitment to innovation.</p>
            </div>

            <div className={styles.hospitalityb}>
              <img className={styles.hospitalityimage} src={h55} alt="hospitality 1"/>
              <p className={styles.hospitalityname}>Enhance <br/>Property Value</p>
              <p className={styles.hospitalitycontent}>Installing EV chargers can increase your hotel's property value
                and help you earn green certifications, attracting eco-conscious guests and investors focused on
                sustainability.</p>
            </div>

            <div className={styles.hospitalityb}>
              <img className={styles.hospitalityimage} src={h66} alt="hospitality 1"/>
              <p className={styles.hospitalityname}>Reduce Range <br/>Anxiety</p>
              <p className={styles.hospitalitycontent}>Offer valet EV charging to provide guests with seamless
                convenience. On-site charging allows guests to explore local attractions without worrying about battery
                range, enhancing their stay.</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.containerbutton}>
        <a href="#start">
          <button className={styles.buttoncta}>Let's talk!</button>
        </a>
      </div>
      <div className={styles.buttoncontainer}>
        <button className={styles.prevbtn} onClick={handlePrev}>
          <img src={arrow2} alt="Previous"/>
        </button>
        <button className={styles.nextbtn} onClick={handleNext}>
          <img src={arrow1} alt="Next"/>
        </button>
      </div>

    </section>
  );
};

export default hospitalitylp;
